var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 15C32.5 16.3787 31.3787 17.5 30 17.5V11.25H32.5V15ZM27.5 17.5C27.5 19.5463 26.6912 21.4575 25.2225 22.8825C23.755 24.3075 21.825 25.0575 19.7675 24.9963C15.76 24.8762 12.5 21.3487 12.5 17.1337V7.5H27.5V17.5ZM10 17.5C8.62125 17.5 7.5 16.3787 7.5 15V11.25H10V17.5ZM32.5 8.75H30V7.5C30 6.12125 28.8787 5 27.5 5H12.5C11.1213 5 10 6.12125 10 7.5V8.75H7.5C6.12125 8.75 5 9.87125 5 11.25V15C5 17.7575 7.2425 20 10 20H10.4025C11.505 23.8975 14.7775 26.8975 18.75 27.4175V32.5H12.5V35H27.5V32.5H21.25V27.4137C23.3937 27.1488 25.3837 26.21 26.9637 24.6763C28.3062 23.3738 29.2237 21.7612 29.675 20H30C32.7575 20 35 17.7575 35 15V11.25C35 9.87125 33.8787 8.75 32.5 8.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.82da010650d228755dbb935115f9b7e2.svg";
export { ForwardRef as ReactComponent };